<template lang="pug">
  div
    section.content-header
      h1 desknet's NEO 接続設定
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active desknet's NEO 接続設定

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="postData", novalidate)
        mixin btnbar
          .row.bcard-btnbar(class!=attributes.class)
            .col-sm-6
              button.btn.btn-primary(:disabled="isLoading" type="submit") 変更
              |
              |
              router-link(:to="{name: 'admin'}")
                button.btn.btn-default キャンセル

        +btnbar

        .callout.callout-info.bcard-callout
          h4 desknet's NEO への接続情報を設定します。
          p
            | desknet's NEO への接続情報を設定することで、名刺バンク２ の名刺情報 を desknet's NEO の AppSuite と連携できます。
            br
            | ※ AppSuite への連携設定は [desknet's NEO 連携] > [AppSuite データ連携設定] から行ってください。
            br
            | ※ AppSuite への連携は AppSuite のご契約が必要です。

        //- 読み込み中はぐるぐる表示
        .panel.panel-default(v-if="isLoading")
          loading

        //- 読み込み中は表示しない
        .box.box-widget(v-if="!isLoading")
          .box-header.with-border
            .box-title 接続設定

          .box-body
            .form-group
              label.control-label(for="bcard-neo-connection-url") desknet's NEO URL
                span.bcard-required (*)
              input#bcard-neo-connection-url.form-control(type="text" v-model="item.neo_url", :maxlength="maxlengths.neo_url" required)

            hr

            .form-group
              label.control-label(for="bcard-neo-basic-id") 基本認証情報: ID
              input#bcard-neo-basic-id.form-control(type="text" v-model="item.basic_id", :maxlength="maxlengths.basic_id")

            .form-group
              label.control-label(for="bcard-neo-basic-pass") 基本認証情報: パスワード
              input#bcard-neo-basic-pass.form-control(type="password" v-model="item.basic_pass", :maxlength="maxlengths.basic_pass")

            .help-block
              p.bcard-comments.text-info
                | ※ desknet's NEO への接続に基本認証が必要な場合に入力してください。

            hr

            .form-group
              label.control-label(for="bcard-neo-proxy-url") プロキシサーバー: ホスト名またはIPアドレス
              input#bcard-neo-proxy-url.form-control(type="text" v-model="item.proxy_host", :maxlength="maxlengths.proxy_host")

            .form-group
              label.control-label(for="bcard-neo-proxy-port") プロキシサーバー: ポート番号
              input#bcard-neo-proxy-port.form-control(type="text" v-model="item.proxy_port", :maxlength="maxlengths.proxy_port")

            .form-group
              label.control-label(for="bcard-neo-proxy-id") プロキシサーバー: 認証ユーザーID
              input#bcard-neo-proxy-id.form-control(type="text" v-model="item.proxy_user_id", :maxlength="maxlengths.proxy_user_id")

            .form-group
              label.control-label(for="bcard-neo-proxy-pass") プロキシサーバー: 認証パスワード
              input#bcard-neo-proxy-pass.form-control(type="password" v-model="item.proxy_pass", :maxlength="maxlengths.proxy_pass")

            .help-block
              p.bcard-comments.text-info
                | ※ desknet's NEOへの接続にプロキシサーバーを使用する場合に入力してください。

            p.bcard-required ※ (*)は必須項目です。

        .box.box-widget(v-if="!isLoading")
          .box-header.with-border
            .box-title アクセスキー設定

          .box-body
            .form-group
              label.control-label(for="bcard-neo-access-key") アクセスキー
                span.bcard-required (*)
              input#bcard-neo-access-key.form-control(type="password" v-model="item.neo_access_key", :maxlength="maxlengths.neo_access_key" required)

            .help-block
              p.bcard-comments.text-info
                | ※ AppSuiteの機能管理権限以上を保有するユーザーのアクセスキーを設定してください。
              p.bcard-comments.text-info
                | ※ アクセスキーは desknet's NEO [個人設定] > [アクセスキー設定] で発行できます。

            p.bcard-required ※ (*)は必須項目です。

        +btnbar.-bottom

</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import Loading from '@/components/molecules/Loading'
import mixinForm from '@/mixins/form'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const NeoConnectionRepository = RepositoryFactory.get('neoconnection')

export default {
  name: 'NeoConnectionSetting',
  components: { AppMessages, Loading },
  mixins: [ mixinForm ],
  data: function () {
    return {
      isLoading: true, // 読み込み中かどうか
      maxlengths: {},

      item: {
        neo_url: '',
        basic_id: '',
        basic_pass: '',
        proxy_host: '',
        proxy_port: '',
        proxy_user_id: '',
        proxy_pass: '',
        neo_access_key: ''
      }
    }
  },
  // 最初にこの機能に入ってきたときに実行される
  created: function () {
    const vm = this
    this.maxlengths = this.loadMaxlengths('NeoConnections')

    // API実行
    NeoConnectionRepository.get()
      .then(function (response) {
        const res = vm.getApiData(response).data
        // responseの入れ替え
        Object.keys(vm.item).forEach(itemKey => {
          vm.item[itemKey] = res[itemKey]
        })
        vm.isLoading = false
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  },
  // データの保存期間設定共通メソッド
  methods: {
    // 送信処理
    postData: function () {
      if (!this.checkFormValidity()) return

      const vm = this

      const sendData = {}

      Object.keys(vm.item).forEach(itemKey => {
        sendData[itemKey] = vm.item[itemKey]
      })

      // API実行
      NeoConnectionRepository.put(sendData)
        .then(function () {
          // 処理成功時はTOPに遷移する
          vm.$router.push({name: 'admin'})
        }).catch(function (error) {
          // エラーメッセージを出す
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/NeoConnectionSetting.vue